import React, { useState } from 'react'
import {
    Button,
    Table,
    Tr,
    Flex,
    PageWrapper,
    PageFooter,
    Th,
    H1WithBack,
    ProfilePicture,
} from '../../styling/GlobalStyles'
import { useSelector } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { useNavigate } from 'react-router'
import { clearScheduledBreaks, getScheduledBreaks } from 'features/breaks/breaksSlice'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import Avatar from '../../assets/images/profileAvatar.png'
import { BodyText } from 'styling/Typography'
import { BreakInDayTimeline } from 'components/BreakInDayTimeline/BreakInDayTimeline'
import styled from 'styled-components'
import { ScheduledBreaksModal } from './ScheduledBreaksModal'

export const ScheduledBreaks: React.FC = () => {
    const { scheduledBreaks } = useSelector((store: RootState) => store.breaks)
    const [params, setParams] = useState<any>(getParams({ location, limit: 30, ap: { date: new Date() } }))
    const [modal, setModal] = useState({ open: false, value: null })
    const navigate = useNavigate()

    useQueryPagination({ fetchFunctions: [getScheduledBreaks], cleanUpFunctions: [clearScheduledBreaks], params })

    // Backend returns the full array (no server-side pagination), so we paginate locally for rendering.
    const allBreaks = scheduledBreaks?.breaks ?? []
    const limit = params?.limit ?? 30
    const page = params?.page ?? 1
    const startIndex = (page - 1) * limit
    const paginatedBreaks = allBreaks.slice(startIndex, startIndex + limit)

    return (
        <>
            <NavBar defaultValue={params.q} setParams={setParams} limit={30} />
            <PageWrapper>
                <Flex between center mb='16' >
                    <H1WithBack title='Scheduled Breaks' arrow />
                    <Flex gap='1rem' alignEnd>
                        <Button orange onClick={() => navigate('templates')}>
                            Templates
                        </Button>
                        <Button orange onClick={() => navigate('policies')}>
                            Policies
                        </Button>
                        <CalendarInput nomarg labelText='Date' defaultValue={params.date} onChange={date => setParams(prev => ({ ...prev, date }))} />
                    </Flex>
                </Flex>
                {!allBreaks.length ? (
                    <NoItems title='Scheduled Breaks' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='30%' noTooltip text='EMPLOYEE' />
                            <Td w='70%' />
                        </Th>
                        {paginatedBreaks.map((item) => {
                            return (
                                <Tr key={item.user.id}>
                                    <Td noTooltip w='30%'>
                                        <Flex center gap='1rem'>
                                            <ProfilePicture mr='20'>
                                                <img
                                                    src={item.user.profileImageUrl || Avatar}
                                                    alt=''
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null
                                                        currentTarget.src = Avatar
                                                    }}
                                                />
                                            </ProfilePicture>
                                            <BodyText>{item.user.firstName + ' ' + item.user.lastName}</BodyText>
                                        </Flex>
                                    </Td>
                                    <Td h='100%' w='70%'>
                                        <DayTimeline>
                                            {item.breaks.map((b) => (
                                                <BreakInDayTimeline
                                                    userId={item.user.id}
                                                    onClick={(value) => setModal({ open: true, value })}
                                                    key={`${b.breakIndex}-${b.scheduledStartTime}`}
                                                    scheduledBreak={{
                                                        breakDuration: b.durationMinutes,
                                                        breakIndex: b.breakIndex,
                                                        scheduledEndTime: b.scheduledEndTime,
                                                        scheduledStartTime: b.scheduledStartTime
                                                    }}
                                                />
                                            ))}
                                        </DayTimeline>
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Table>
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(allBreaks.length / limit)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
            {modal.open && <ScheduledBreaksModal closeModal={() => setModal({ open: false, value: null })} value={modal.value} />}
        </>
    )
}

const DayTimeline = styled.div`

        width: 100%;
        height:  95%;
        border-radius: 10px;
        position: relative;
        overflow: hidden;
        background-color: #ff9900;

`